import { Link, Typography } from "@mui/material";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const REDIRECT_DOMAIN = getEnvironmentVariable("REDIRECT_DOMAIN");
const COMPANY_NAME =
  getEnvironmentVariable("COMPANY_NAME") || "Best Coast Pairings";

export default function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link
        color="inherit"
        href={REDIRECT_DOMAIN || "https://www.bestcoastpairings.com/"}
      >
        {COMPANY_NAME}
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
